import styles from './SupportedBanks.module.scss';
import { IApplicationState } from '@spinwise/spinwise-core';
import { useSelector } from 'react-redux';
import { useRef, useState } from 'react';
import classNames from 'classnames';
import { EBaseButtonSize, EBaseButtonType } from '@spinwise/react-component-library/ButtonAbstract';
import { IconVariantsLibrary } from 'Libraries/variants.library';
import { IconLibrary } from 'Libraries/icons.library';
import useHorizontalScroll from 'Hooks/useHorizontalScroll';
import { ButtonIconOnly } from '@spinwise/react-component-library/ButtonIconOnly';
import { EGuestHomepageVersions } from 'Components/pages/GuestHomepage/types';

const BanksMap = new Map<string, string[]>([
  ['FIN', ['nordea', 'danske', 'op', 'aktia', 's-pankki']],
  ['EST', ['swedbank', 'seb', 'lhv', 'luminor']],
]);

const NAVIGATION_SCROLL_OFFSET = 150;

interface ISupportedBanksProps {
  version?: EGuestHomepageVersions;
}
const SupportedBanks = ({ version = EGuestHomepageVersions.B }: ISupportedBanksProps) => {
  const { geo } = useSelector((state: IApplicationState) => state.globalReducer);

  const banks = BanksMap.get(geo?.code) ?? [];

  const navRef = useRef<HTMLDivElement>();
  const { scrollTo } = useHorizontalScroll(0, navRef);

  const [buttonColor, setButtonColor] = useState(
    version == EGuestHomepageVersions.B || version == EGuestHomepageVersions.B2
      ? 'rgba(127, 48, 227, 0.75)'
      : 'var(--w-white-30, rgba(255, 255, 255, 0.30))',
  );

  return (
    <>
      <div className={`${styles.payment_support_container} d-fl ai-c`} ref={navRef}>
        <div
          className={classNames(styles.nav_arrow, styles.nav_arrow__left)}
          style={{ background: buttonColor }}
          onClick={() =>
            scrollTo({
              side: 'left',
              offset: NAVIGATION_SCROLL_OFFSET,
            })
          }
        >
          <ButtonIconOnly
            size={EBaseButtonSize.Small}
            type={EBaseButtonType.None}
            isStatic={true}
            variant={IconVariantsLibrary.White}
            isMasked={true}
            iconName={IconLibrary.ArrowRight}
          />
        </div>
        <div className={`${styles.payment_support_block} d-fl ai-c jc-c`}>
          {banks.map(bank => (
            <div key={bank} className={classNames(styles.payment_support_block__item, 'd-fl ai-c jc-c')}>
              <img loading="lazy" src={`/images/payments/${bank}.svg`} alt="" key={bank} />
            </div>
          ))}
        </div>
        <div
          className={styles.nav_arrow}
          style={{ background: buttonColor }}
          onClick={() =>
            scrollTo({
              side: 'right',
              offset: NAVIGATION_SCROLL_OFFSET,
            })
          }
        >
          <ButtonIconOnly
            size={EBaseButtonSize.Small}
            type={EBaseButtonType.None}
            isStatic={true}
            variant={IconVariantsLibrary.White}
            isMasked={true}
            iconName={IconLibrary.ArrowRight}
          />
        </div>
      </div>
    </>
  );
};

export default SupportedBanks;
